module.exports = __webpack_public_path__ + "assets/img/shock.4eaea444.svg";